export default __webpack_public_path__ + "static/media/placeholder_private03-en-mobile.8c5e5232.png";